import Vue from 'vue'
import Router from 'vue-router'
import Head from 'vue-head'
import Home from '@/views/Home'
import CheckLogin from '@/views/CheckLogin'
import store from '@/store'

Vue.use(Router)

/* If you don't know about VueHead, please refer to https://github.com/ktquez/vue-head */
Vue.use(Head, {
  complement: process.env.VUE_APP_TITLE
})

/* If you don't know about VueRouter, please refer to https://router.vuejs.org/ */
const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        authNotRequired: true
      }
    },
    {
      path: '/check-login',
      name: 'check-login',
      component: CheckLogin,
      meta: {
        authNotRequired: true
      }
    },
    {
      path: '/login',
      name: 'login',
      /* webpackChunkName: "client-chunk-login" */
      component: () => import('@/views/Login.vue'),
      meta: {
        authNotRequired: true
      }
    },
    {
      path: '/groups',
      name: 'groups',
      component: () => import('@/views/Groups.vue')
    },
    {
      path: '/events',
      name: 'events',
      component: () => import('@/views/Events.vue'),
      meta: {
        authNotRequired: true
      }
    },
    {
      path: '/directory',
      name: 'directory',
      component: () => import('@/views/Directory.vue')
    },
    {
      path: '/more',
      name: 'more',
      component: () => import('@/views/More.vue')
    },
    {
      path: '/profile',
      name: 'profile',
      component: () => import('@/views/Profile.vue')
    },
    { path: '*', redirect: '/' }
  ]
})

/**
 * Handle user redirections
 */
// eslint-disable-next-line consistent-return
router.beforeEach((to, from, next) => {
  const { user } = store.state.authentication

  console.log(to, user)
  if (to.meta) {
    console.log(to.meta)
  } else {
    console.log('no meta')
  }
  if (to.meta.authNotRequired) {
    console.log(to.meta.authNotRequired)
  } else {
    console.log('no to.meta.authNotRequired')
  }

  // Allow routes that don't require authentication
  if (to.meta && to.meta.authNotRequired) {
    console.log('no auth required')
    return next()
  }

  // If user state is still undefined (Firebase auth not initialized yet), redirect to check-login
  if (user === undefined) {
    console.log('user undefined, check-login')
    return next(`/check-login?redirectUrl=${to.path}`)
  }

  // If user is null (logged out), redirect to login
  if (user === null) {
    console.log('redirect to login')
    return next(`/login?redirectUrl=${to.path}`)
  }

  // User is authenticated, allow navigation
  next()
})

export default router
